import * as Yup from 'yup';
import { cloneDeep } from 'lodash';

import i18n from '../components/localization/i18n';
import { isDev } from '../helpers/Utils';

export const LicenseStatus = {
    NotFound: 0,
    Active  : 1,
    Expired : 2
}

export const ImageType = {
    AppSplash: "AppSplash",
    AppIcon: "AppIcon",
    MenuHeader: "MenuHeader",
    PhotoEditor: "PhotoEditor",
    LoginPage: "LoginPage",
    MenuItem: "MenuItem",
}

export const FileType = {
    iOSP12Certificate: "iOSP12Certificate",
    iOSP8Certificate: "iOSP8Certificate",
    iOSMobileProvisioning: "iOSMobileProvisioning",
    AndroidKeyStore: "AndroidKeyStore"
}

export const BuildType = {
    Android: "Android",
    iOS: "iOS"
}

export const MenuLayoutType = {
    Drawer: "Drawer",
    Tiles: "Tiles",
    Tabs: "Tabs"
}

export const UserLoginType = {
    None: "None",
    Always: "Always",
    Action: "Action",
    Code: "Code"
}

export const PostListLayoutType = {
    OneColumnPictureWithText: "OneColumnPictureWithText",
    OneColumnPictureWithDetails: "OneColumnPictureWithDetails",
    TwoColumnsPictureWithText: "TwoColumnsPictureWithText"
}

export const ProcessStatus = {
    Enqueued: "Enqueued",
    Processing: "Processing",
    Completed: "Completed",
    Canceled: "Canceled",
    Faulty: "Faulty"
}

export const MaxFileSize = {
    Max5MB: 5242880,
    Max1MB: 1048576,
}

export const MenuItemTypes = {
    HomePage: "HomePage",
    BusinessCard: "BusinessCard",
    MailTo: "MailTo",
    EmptyLine: "EmptyLine",
    OpenURL: "OpenURL",
    PhoneCall: "PhoneCall",
    PhotoEditor: "PhotoEditor",
    PhotoSend: "PhotoSend",
    QR: "QR",
    Separator: "Separator",
    SendSms: "SendSms",
    OnLineWebView: "OnLineWebView",
    Label: {
        HomePage: i18n.t("MenuItemHomePage"),
        BusinessCard: i18n.t("MenuItemBusinessCard"),
        MailTo: i18n.t("MenuItemMailTo"),
        EmptyLine: i18n.t("MenuItemEmptyLine"),
        OpenURL: i18n.t("MenuItemOpenURL"),
        PhoneCall: i18n.t("MenuItemPhoneCall"),
     // PhotoEditor: i18n.t("MenuItemPhotoEditor"),
        PhotoSend: i18n.t("MenuItemPhotoSend"),
        QR: i18n.t("MenuItemQR"),
        Separator: i18n.t("MenuItemSeparator"),
        SendSms: i18n.t("MenuItemSendSms"),
        OnLineWebView: i18n.t("MenuItemOnLineWebView"),
    }
}

const CommonMenuItem = {
    hideIcon: false,
    hideTitle: false
}

export const MenuItemDefaultValue = {
    HomePage: {
        ...cloneDeep(CommonMenuItem),
        type: MenuItemTypes.HomePage,
        icon: "fa fa-home",
        iconCode: "f015",
        title: i18n.t("MenuItemHomePage"),
        backgroundColor: "#7957D5",
        backgroundImage: null,
        textColor: "#000000",
        fontSize: "medium",
        fontStyle: "regular",
        platform: "ios, android",
        isVisible: true,
        isProtected: false,
        props: {
            isAbsoluteUrl: true,
            url: "",
            wpUrl: ""
        }
    },
    BusinessCard: {
        ...cloneDeep(CommonMenuItem),
        type: MenuItemTypes.BusinessCard,
        icon: "fa fa-address-card",
        iconCode: "f2bb",
        title: i18n.t("MenuItemBusinessCard"),
        backgroundColor: "#7957D5",
        backgroundImage: null,
        textColor: "#000000",
        fontSize: "medium",
        fontStyle: "regular",
        platform: "ios, android",
        isVisible: true,
        isProtected: false,
        props: {
            templateId: ""
        }
    },
    MailTo: {
        ...cloneDeep(CommonMenuItem),
        type: MenuItemTypes.MailTo,
        icon: "fa fa-envelope",
        iconCode: "f0e0",
        title: i18n.t("MenuItemMailTo"),
        backgroundColor: "#7957D5",
        backgroundImage: null,
        textColor: "#000000",
        fontSize: "medium",
        fontStyle: "regular",
        platform: "ios, android",
        isVisible: true,
        isProtected: false,
        props: {
            email: ""
        }
    },
    EmptyLine: {
        ...cloneDeep(CommonMenuItem),
        type: MenuItemTypes.EmptyLine,
        icon: "fa fa-align-justify",
        iconCode: "f039",
        title: i18n.t("MenuItemEmptyLine"),
        backgroundColor: "#7957D5",
        backgroundImage: null,
        platform: "ios, android",
        isVisible: true,
        isProtected: false,
        props: {
        }
    },
    OpenURL: {
        ...cloneDeep(CommonMenuItem),
        type: MenuItemTypes.OpenURL,
        icon: "fa fa-external-link",
        iconCode: "f08e",
        title: i18n.t("MenuItemOpenURL"),
        backgroundColor: "#7957D5",
        backgroundImage: null,
        textColor: "#000000",
        fontSize: "medium",
        fontStyle: "regular",
        platform: "ios, android",
        isVisible: true,
        isProtected: false,
        props: {
            isAbsoluteUrl: true,
            url: "",
            wpUrl: ""
        }
    },
    PhoneCall: {
        ...cloneDeep(CommonMenuItem),
        type: MenuItemTypes.PhoneCall,
        icon: "fa fa-phone",
        iconCode: "f095",
        title: i18n.t("MenuItemPhoneCall"),
        backgroundColor: "#7957D5",
        backgroundImage: null,
        textColor: "#000000",
        fontSize: "medium",
        fontStyle: "regular",
        platform: "ios, android",
        isVisible: true,
        isProtected: false,
        props: {
            phoneNumber: ""
        }
    },
    //PhotoEditor: {
    //    ...cloneDeep(CommonMenuItem),
    //    type: MenuItemTypes.PhotoEditor,
    //    icon: "fa fa-picture-o",
    //    iconCode: "f03e",
    //    title: i18n.t("MenuItemPhotoEditor"),
    //    backgroundColor: "#7957D5",
    //    backgroundImage: null,
    //    textColor: "#000000",
    //    fontSize: "medium",
    //    fontStyle: "regular",
    //    platform: "ios, android",
    //    isVisible: true,
    //    isProtected: false,
    //    props: {
    //        imageSource: "images",
    //        jsonUrl: "",
    //        images: [],
    //        isHelpPageAbsoluteUrl: true,
    //        helpPageUrl: "",
    //        helpPageWpUrl: "",
    //        mode: "all"
    //    }
    //},
    PhotoSend: {
        ...cloneDeep(CommonMenuItem),
        type: MenuItemTypes.PhotoSend,
        icon: "fa fa-share",
        iconCode: "f064",
        title: i18n.t("MenuItemPhotoSend"),
        backgroundColor: "#7957D5",
        backgroundImage: null,
        textColor: "#000000",
        fontSize: "medium",
        fontStyle: "regular",
        platform: "ios, android",
        isVisible: true,
        isProtected: false,
        props: {
            email: ""
        }
    },
    QR: {
        ...cloneDeep(CommonMenuItem),
        type: MenuItemTypes.QR,
        icon: "fa fa-qrcode",
        iconCode: "f029",
        title: i18n.t("MenuItemQR"),
        backgroundColor: "#7957D5",
        backgroundImage: null,
        textColor: "#000000",
        fontSize: "medium",
        fontStyle: "regular",
        platform: "ios, android",
        isVisible: true,
        isProtected: false,
        props: {
            url: ""
        }
    },
    Separator: {
        ...cloneDeep(CommonMenuItem),
        type: MenuItemTypes.Separator,
        icon: "fa fa-sort",
        iconCode: "f0dc",
        title: i18n.t("MenuItemSeparator"),
        backgroundColor: "#7957D5",
        backgroundImage: null,
        textColor: "#000000",
        platform: "ios, android",
        isVisible: true,
        isProtected: false,
        props: {
            thickness: 1
        }
    },
    SendSms: {
        ...cloneDeep(CommonMenuItem),
        type: MenuItemTypes.SendSms,
        icon: "fa fa-commenting",
        iconCode: "f27a",
        title: i18n.t("MenuItemSendSms"),
        backgroundColor: "#7957D5",
        backgroundImage: null,
        textColor: "#000000",
        fontSize: "medium",
        fontStyle: "regular",
        platform: "ios, android",
        isVisible: true,
        isProtected: false,
        props: {
            phoneNumber: ""
        }
    },
    OnLineWebView: {
        ...cloneDeep(CommonMenuItem),
        type: MenuItemTypes.OnLineWebView,
        icon: "fa fa-code",
        iconCode: "f121",
        title: i18n.t("MenuItemOnLineWebView"),
        backgroundColor: "#7957D5",
        backgroundImage: null,
        textColor: "#000000",
        fontSize: "medium",
        fontStyle: "regular",
        platform: "ios, android",
        isVisible: true,
        isProtected: false,
        props: {
            allowShare: false,
            isAbsoluteUrl: true,
            url: "",
            wpUrl: ""
        }
    },
}

const validUrlRegEx = /(https?:\/\/.*)(:*)(\d*)\/?(.*)/g
const getValidUrlRegEx = () => {
    return validUrlRegEx;
}

export const MenuItemValidateSchema = {
    HomePage:
        Yup.object().shape({
            type: Yup.string().required(i18n.t("YupValueRequired")),
            icon: Yup.string().required(i18n.t("YupValueRequired")),
            title: Yup.string().required(i18n.t("YupTitleRequired")),
            backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            textColor: Yup.string().required(i18n.t("YupValueRequired")),
            fontSize: Yup.string().required(i18n.t("YupValueRequired")),
            fontStyle: Yup.string().required(i18n.t("YupValueRequired")),
            platform: Yup.string().required(i18n.t("YupValueRequired")),
            isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
            props: Yup.object().shape({
                isAbsoluteUrl: Yup.boolean().required(i18n.t("YupValueRequired")),
                url: Yup.string().nullable().when('isAbsoluteUrl', {
                    is: true,
                    then: Yup.string().nullable().matches(getValidUrlRegEx(), i18n.t("YupValidUrlRequired")).required(i18n.t("YupLinkRequired"))
                }),
                wpUrl: Yup.string().nullable().when('isAbsoluteUrl', {
                    is: false,
                    then: Yup.string().nullable().required(i18n.t("YupLinkRequired"))
                })
            })
        }),
    BusinessCard:
        Yup.object().shape({
            type: Yup.string().required(i18n.t("YupValueRequired")),
            icon: Yup.string().required(i18n.t("YupValueRequired")),
            title: Yup.string().required(i18n.t("YupTitleRequired")),
            backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            textColor: Yup.string().required(i18n.t("YupValueRequired")),
            fontSize: Yup.string().required(i18n.t("YupValueRequired")),
            fontStyle: Yup.string().required(i18n.t("YupValueRequired")),
            platform: Yup.string().required(i18n.t("YupValueRequired")),
            isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
            props: Yup.object().shape({
                templateId: Yup.string().required(i18n.t("YupTemplateIdRequired"))
            })
        }),
    MailTo:
        Yup.object().shape({
            type: Yup.string().required(i18n.t("YupValueRequired")),
            icon: Yup.string().required(i18n.t("YupValueRequired")),
            title: Yup.string().required(i18n.t("YupTitleRequired")),
            backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            textColor: Yup.string().required(i18n.t("YupValueRequired")),
            fontSize: Yup.string().required(i18n.t("YupValueRequired")),
            fontStyle: Yup.string().required(i18n.t("YupValueRequired")),
            platform: Yup.string().required(i18n.t("YupValueRequired")),
            isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
            props: Yup.object().shape({
                email: Yup.string().email(i18n.t("YupEmailRequired")).required(i18n.t("YupEmailRequired"))
            })
        }),
    EmptyLine:
        Yup.object().shape({
            type: Yup.string().required(i18n.t("YupValueRequired")),
            icon: Yup.string().required(i18n.t("YupValueRequired")),
            backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            platform: Yup.string().required(i18n.t("YupValueRequired")),
            isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
        }),
    OpenURL:
        Yup.object().shape({
            type: Yup.string().required(i18n.t("YupValueRequired")),
            icon: Yup.string().required(i18n.t("YupValueRequired")),
            title: Yup.string().required(i18n.t("YupTitleRequired")),
            backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            textColor: Yup.string().required(i18n.t("YupValueRequired")),
            fontSize: Yup.string().required(i18n.t("YupValueRequired")),
            fontStyle: Yup.string().required(i18n.t("YupValueRequired")),
            platform: Yup.string().required(i18n.t("YupValueRequired")),
            isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
            props: Yup.object().shape({
                isAbsoluteUrl: Yup.boolean().required(i18n.t("YupValueRequired")),
                url: Yup.string().nullable().when('isAbsoluteUrl', {
                    is: true,
                    then: Yup.string().nullable().matches(getValidUrlRegEx(), i18n.t("YupValidUrlRequired")).required(i18n.t("YupLinkRequired"))
                }),
                wpUrl: Yup.string().nullable().when('isAbsoluteUrl', {
                    is: false,
                    then: Yup.string().nullable().required(i18n.t("YupLinkRequired"))
                })
            })
        }),
    PhoneCall:
        Yup.object().shape({
            type: Yup.string().required(i18n.t("YupValueRequired")),
            icon: Yup.string().required(i18n.t("YupValueRequired")),
            title: Yup.string().required(i18n.t("YupTitleRequired")),
            backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            textColor: Yup.string().required(i18n.t("YupValueRequired")),
            fontSize: Yup.string().required(i18n.t("YupValueRequired")),
            fontStyle: Yup.string().required(i18n.t("YupValueRequired")),
            platform: Yup.string().required(i18n.t("YupValueRequired")),
            isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
            props: Yup.object().shape({
                phoneNumber: Yup.string()
                    // Does a world wide generic reg ex even exists?
                    //.matches("/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/", 'Phone number is not valid')
                    .required(i18n.t("YupPhoneNumberRequired"))
            })
        }),
    //PhotoEditor:
    //    Yup.object().shape({
    //        type: Yup.string().required(i18n.t("YupValueRequired")),
    //        icon: Yup.string().required(i18n.t("YupValueRequired")),
    //        title: Yup.string().required(i18n.t("YupTitleRequired")),
    //        backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
    //        textColor: Yup.string().required(i18n.t("YupValueRequired")),
    //        fontSize: Yup.string().required(i18n.t("YupValueRequired")),
    //        fontStyle: Yup.string().required(i18n.t("YupValueRequired")),
    //        platform: Yup.string().required(i18n.t("YupValueRequired")),
    //        isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
    //        props: Yup.object().shape({
    //            jsonUrl: Yup.string().when("imageSource", {
    //                is: "url",
    //                then: Yup.string().matches(getValidUrlRegEx(), i18n.t("YupValidUrlRequired")).required(i18n.t("YupLinkRequired"))
    //            }),
    //            helpPageUrl: Yup.string().nullable().when(["imageSource", "isHelpPageAbsoluteUrl"], {
    //                is: (p1, p2) => p1 === "images" && p2 === true,
    //                then: Yup.string().nullable().matches(getValidUrlRegEx(), i18n.t("YupValidUrlRequired")).required(i18n.t("YupLinkRequired"))
    //            }),
    //            helpPageWpUrl: Yup.string().nullable().when(["imageSource", "isHelpPageAbsoluteUrl"], {
    //                is: (p1, p2) => p1 === "images" && p2 === false,
    //                then: Yup.string().nullable().required(i18n.t("YupLinkRequired"))
    //            })
    //        })
    //    }),
    PhotoSend:
        Yup.object().shape({
            type: Yup.string().required(i18n.t("YupValueRequired")),
            icon: Yup.string().required(i18n.t("YupValueRequired")),
            title: Yup.string().required(i18n.t("YupTitleRequired")),
            backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            textColor: Yup.string().required(i18n.t("YupValueRequired")),
            fontSize: Yup.string().required(i18n.t("YupValueRequired")),
            fontStyle: Yup.string().required(i18n.t("YupValueRequired")),
            platform: Yup.string().required(i18n.t("YupValueRequired")),
            isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
            props: Yup.object().shape({
                email: Yup.string().email(i18n.t("YupValidEmailRequired")).required(i18n.t("YupEmailRequired"))
            })
        }),
    QR:
        Yup.object().shape({
            type: Yup.string().required(i18n.t("YupValueRequired")),
            icon: Yup.string().required(i18n.t("YupValueRequired")),
            title: Yup.string().required(i18n.t("YupTitleRequired")),
            backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            textColor: Yup.string().required(i18n.t("YupValueRequired")),
            fontSize: Yup.string().required(i18n.t("YupValueRequired")),
            fontStyle: Yup.string().required(i18n.t("YupValueRequired")),
            platform: Yup.string().required(i18n.t("YupValueRequired")),
            isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
            props: Yup.object().shape({
                url: Yup.string().matches(getValidUrlRegEx(), i18n.t("YupValidUrlRequired")).required(i18n.t("YupUrlRequired"))
            })
        }),
    Separator:
        Yup.object().shape({
            type: Yup.string().required(i18n.t("YupValueRequired")),
            icon: Yup.string().required(i18n.t("YupValueRequired")),
            backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            platform: Yup.string().required(i18n.t("YupValueRequired")),
            isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
            props: Yup.object().shape({
                thickness: Yup.number().min(1).required(i18n.t("YupValueRequired"))
            })
        }),
    SendSms:
        Yup.object().shape({
            type: Yup.string().required(i18n.t("YupValueRequired")),
            icon: Yup.string().required(i18n.t("YupValueRequired")),
            title: Yup.string().required(i18n.t("YupTitleRequired")),
            backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            textColor: Yup.string().required(i18n.t("YupValueRequired")),
            fontSize: Yup.string().required(i18n.t("YupValueRequired")),
            fontStyle: Yup.string().required(i18n.t("YupValueRequired")),
            platform: Yup.string().required(i18n.t("YupValueRequired")),
            isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
            props: Yup.object().shape({
                phoneNumber: Yup.string()
                    // Does a world wide generic reg ex even exists?
                    //.matches("/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/", 'Phone number is not valid')
                    .required(i18n.t("YupPhoneNumberRequired"))
            })
        }),
    OnLineWebView:
        Yup.object().shape({
            type: Yup.string().required(i18n.t("YupValueRequired")),
            icon: Yup.string().required(i18n.t("YupValueRequired")),
            title: Yup.string().required(i18n.t("YupTitleRequired")),
            backgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            textColor: Yup.string().required(i18n.t("YupValueRequired")),
            fontSize: Yup.string().required(i18n.t("YupValueRequired")),
            fontStyle: Yup.string().required(i18n.t("YupValueRequired")),
            platform: Yup.string().required(i18n.t("YupValueRequired")),
            isVisible: Yup.boolean().required(i18n.t("YupValueRequired")),
            props: Yup.object().shape({
                isAbsoluteUrl: Yup.boolean().required(i18n.t("YupValueRequired")),
                url: Yup.string().nullable().when('isAbsoluteUrl', {
                    is: true,
                    then: Yup.string().nullable().matches(getValidUrlRegEx(), i18n.t("YupValidUrlRequired")).required(i18n.t("YupLinkRequired"))
                }),
                wpUrl: Yup.string().nullable().when('isAbsoluteUrl', {
                    is: false,
                    then: Yup.string().nullable().required(i18n.t("YupLinkRequired"))
                })
            })
        }),
}

export const SettingsValidateSchema = {
    Info:
        Yup.object().shape({
            menuTitle: Yup.string().required(i18n.t("YupValueRequired")),
          //versionNumber: Yup.string().required(i18n.t("YupValueRequired")),
            shareAppIos: Yup.string().nullable(),
            shareAppAndroid: Yup.string().nullable(),
            enableAppMenu: Yup.boolean().required(i18n.t("YupValueRequired")),
            //homeUrl: Yup.string().nullable().when('enableAppMenu', {
            //    is: false,
            //    then: Yup.string().nullable().matches(getValidUrlRegEx(), i18n.t("YupValidUrlRequired")).required(i18n.t("YupValueRequired"))
            //}),
            appPrimaryColor: Yup.string().required(i18n.t("YupValueRequired")),
            appSecondaryColor: Yup.string().required(i18n.t("YupValueRequired")),
            appTitleColor: Yup.string().required(i18n.t("YupValueRequired")),
            colorHeaderMenu: Yup.string().required(i18n.t("YupValueRequired")),
            menuTitleBackgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            menuItemsBackgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
            menuItemsTextColor: Yup.string().required(i18n.t("YupValueRequired")),
            menuBackgroundColor: Yup.string().required(i18n.t("YupValueRequired")),
        }),
    Assets:
        Yup.object().shape({
         //   appSplashImage: Yup.string().url(i18n.t("YupValidUrlRequired")).required(i18n.t("YupFileRequired")),
         //   appIcon: Yup.string().url(i18n.t("YupValidUrlRequired")).required(i18n.t("YupFileRequired")),
        }),

   Ios:
      Yup.object().shape({
         appTitle: Yup.string().required(i18n.t("YupValueRequired")),
         bundleId: Yup.string().matches(/^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+[0-9a-z_]$/i, i18n.t("YupInvalidBundleId")).required(i18n.t("YupValueRequired")),
      }),

   Ios1:
      Yup.object().shape({
         enableAndroidBuild: Yup.boolean().required(i18n.t("YupValueRequired")),
         androidKeyStoreFile: Yup.string().nullable().when("enableAndroidBuild", {
            is: true,
            then: Yup.string().nullable().required(i18n.t("YupFileRequired")),
         }),
         /*
         androidKeyStoreAlias: Yup.string().when("enableAndroidBuild", {
             is: true,
             then: Yup.string().required(i18n.t("YupValueRequired")),
         }),
         */
         androidKeyStorePassword: Yup.string().when("enableAndroidBuild", {
            is: true,
            then: Yup.string().required(i18n.t("YupValueRequired")),
         }),
      }),

    Ios2:
        Yup.object().shape({
            enableiOSBuild: Yup.boolean().required(i18n.t("YupValueRequired")),
            iOSP12CertificateFile: Yup.string().nullable().when('enableiOSBuild', {
                is: true,
                then: Yup.string().nullable().required(i18n.t("YupFileRequired"))
            }),
            iOSCertificatePassword: Yup.string().when('enableiOSBuild', {
                is: true,
                then: Yup.string().required(i18n.t("YupValueRequired"))
            }),
            iOSMobileProvisionFile: Yup.string().nullable().when('enableiOSBuild', {
                is: true,
                then: Yup.string().nullable().required(i18n.t("YupFileRequired"))
            }),
        }),


    Services:
        Yup.object().shape({
            //oneSignalAppId: Yup.string().required('The one signal app id is required'),
            //sendGripApiKey: Yup.string().required('The send grip api key is required'),
        })
}

export const Aphorisms = [
    { author: "Steve Jobs", phrase: "“Your time is limited, so don’t waste it living someone else’s life.”" },
    { author: "Steve Jobs", phrase: "“You can’t connect the dots looking forward; you can only connect them looking backward. So you have to trust that the dots will somehow connect in your future.”" },
    { author: "Steve Jobs", phrase: "“Don’t let the noise of others’ opinions drown out your own inner voice.”" },
    { author: "Steve Jobs", phrase: "“Have the courage to follow your heart and intuition. They somehow already know what you truly want to become.”" },
    { author: "Steve Jobs", phrase: "“Stay hungry. Stay foolish.”" },
    { author: "Steve Jobs", phrase: "“If today were the last day of your life, would you want to do what you are about to do today?”" },
    { author: "Steve Jobs", phrase: "“I think the things you regret most in life are the things you didn’t do.”" },
    { author: "Steve Jobs", phrase: "“Remembering that you are going to die is the best way I know to avoid the trap of thinking you have something to lose.”" },
    { author: "Steve Jobs", phrase: "“We’re here to put a dent in the universe. Otherwise why else even be here?”" },
    { author: "Steve Jobs", phrase: "“Sometimes when you innovate, you make mistakes. It is best to admit them quickly, and get on with improving your other innovations.”" },
    { author: "Steve Jobs", phrase: "“My favorite things in life don’t cost any money. It’s really clear that the most precious resource we all have is time.”" },
    { author: "Steve Jobs", phrase: "“I’m convinced that about half of what separates successful entrepreneurs from the non-successful ones is pure perseverance.”" },
    { author: "Steve Jobs", phrase: "“Innovation distinguishes between a leader and a follower.”" },
    { author: "Steve Jobs", phrase: "“I think if you do something and it turns out pretty good, then you should go do something else wonderful, not dwell on it for too long. Just figure out what’s next.”" },
    { author: "Steve Jobs", phrase: "“Your work is going to fill a large part of your life, and the only way to be truly satisfied is to do what you believe is great work. And the only way to do great work is to love what you do. If you haven’t found it yet, keep looking. Don’t settle. As with all matters of the heart, you’ll know when you find it.”" },
    { author: "Plato", phrase: "“There is truth in wine and children.”" },
    { author: "Napoleon Bonaparte", phrase: "“If you want a thing done well, do it yourself.”" },
    { author: "Nelson Mandela", phrase: "“The greatest glory in living lies not in never falling, but in rising every time we fall.”" },
    { author: "Walt Disney", phrase: "“The way to get started is to quit talking and begin doing.”" },
    { author: "Eleanor Roosevelt", phrase: "“If life were predictable it would cease to be life, and be without flavor.”" },
    { author: "John Lennon", phrase: "“Life is what happens when you're busy making other plans.”" },
    { author: "Benjamin Franklin", phrase: "“Tell me and I forget. Teach me and I remember. Involve me and I learn.”" },
    { author: "Aristotle", phrase: "“It is during our darkest moments that we must focus to see the light.”" },
    { author: "Anne Frank", phrase: "“Whoever is happy will make others happy too.”" },
    { author: "Albert Einstein", phrase: "“Only a life lived for others is a life worthwhile.”" },
    { author: "Dalai Lama", phrase: "“The purpose of our lives is to be happy.”" },
    { author: "William Shakespeare", phrase: "“Wisely, and slow. They stumble that run fast.”" },
    { author: "Mother Teresa", phrase: "“If you judge people, you have no time to love them.”" },
    { author: "Buddha", phrase: "“All that we are is the result of what we have thought.”" },
    { author: "Albert Einstein", phrase: "“Insanity: doing the same thing over and over again and expecting different results.”" },
    { author: "John F. Kennedy", phrase: "“Those who dare to fail miserably can achieve greatly.”" },
    { author: "Muhammad Ali", phrase: "“Don’t count the days, make the days count.”" },
    { author: "Julius Caesar", phrase: "“I came, I saw, I conquered.”" },
]